<template>
  <div class="min-h-screen flex flex-col bg-slate-50">
    <header class="sticky top-0 z-[1100] w-full bg-white shadow-lg">
      <LayoutMenuTop class="hidden lg:flex" />
      <LayoutMenuMain />
      <LayoutBreadCrumbs />
    </header>
    <main class="flex-grow">
      <slot />
    </main>
    <footer>
      <LayoutFooterMain />
    </footer>
    <SearchModal />
  </div>
</template>
